
import EnhancedStats from "./EnhancedStats";

const Stats = () => {
  return <EnhancedStats />;
};

export default Stats;
